<template>
    <div>
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex lg12>
                    <hpo-filter placeholder="Tìm kiếm theo khách hàng" :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true"  :mobile-breakpoint="100">
                        :server-items-length="items.length" :must-sort="true" 
                        :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ item.Username }}</td>
                                <td>{{ item.StoreExpID | display_value(storeExpList, 'ID', 'Name') }}</td>
                                <td class="text-end">{{ item.TotalOrder | currency }}</td>
                                <td class="text-end">{{ item.TotalPack | currency }}</td>
                                <td class="text-end">{{ item.NumberOfPack | currency }}</td>
                                <td class="text-end">{{ item.Weight | currency('', 2) }}</td>
                                <td class="text-end">{{ item.Volume | currency('', 3) }}</td>
                                <td class="text-end" v-if="!roleStore">{{ item.TotalAmount | currency }}</td>
                                <td class="text-end" v-if="!roleStore">{{ item.Payment | currency }}</td>
                                <td class="text-end" v-if="item.RemainAmount > 0">{{ item.RemainAmount | currency }}</td>
                                <td class="text-end" v-else>0</td>
                                <td class="text-end">{{ item.Wallet | currency }}</td>
                                <td class="text-center">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                        <v-btn icon v-on="on" @click="print_data(item)">
                                        <v-icon color="red darken-2" class="mr-2">fa-print</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>In phiếu</span>
                                    </v-tooltip>
                            </td>
                            </tr>
                        </template>
                        <template v-slot:body.append>
                            <tr class="total-summary-td">
                                <td class="font-weight-bold" colspan="2">TỔNG</td>
                                <td class="text-end font-weight-bold">{{ summary.TotalOrder | currency }}</td>
                                <td class="text-end font-weight-bold">{{ summary.TotalPack | currency }}</td>
                                <td class="text-end font-weight-bold">{{ summary.NumberOfPack | currency }}</td>
                                <td class="text-end font-weight-bold">{{ summary.Weight | currency('', 2) }}</td>
                                <td class="text-end font-weight-bold">{{ summary.Volume | currency('', 3) }}</td>
                                <td class="text-end font-weight-bold" v-if="!roleStore">{{ summary.TotalAmount | currency }}</td>
                                <td class="text-end font-weight-bold" v-if="!roleStore">{{ summary.Payment | currency }}</td>
                                <td class="text-end font-weight-bold">{{ summary.RemainAmount | currency }}</td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold"></td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import Filtering from "@/components/Filtering";
import { print_inventory } from '@/commons/hpod';
export default {
    components: {
        "hpo-filter": Filtering,
    },
    data() {
        return {
            pagination: { ...configs.PAGINATION, sortBy: ["UID"] },
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "bao-cao-ton-kho-vn",
            filterConditions: [],
            quickFilterConditions: [],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        storeExpList() {
            let header_item = _.find(this.headers, {value: "StoreExpID"});
            if(header_item) {
                header_item.values = _.map(this.storeExpList, (item) => {
                return {
                    value: item.ID,
                    name: item.Name
                }
                }) || []
            }
        },
    },
    computed: {
        ...mapState({
            items: state => state.report.inventoryReport.data,
            total_rows: state => state.report.inventoryReport.total,
            summary: state => state.report.inventoryReport.summary,
            storeExpList: state => state.storeExp.all.data,
            loading: state => state.report.loading
        }),
        roleAdmin() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        roleStore() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ;
        },
        headers() {
            if(this.roleStore) {
                return [
                    {
                        text: "Khách hàng",
                        value: "Username",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Kho nhận",
                        value: "StoreExpID",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Enum"],
                        values: []
                    },
                    {
                        text: "Tổng đơn",
                        value: "TotalOrder",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tổng mã",
                        value: "TotalPack",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tổng kiện",
                        value: "NumberOfPack",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tổng cân",
                        value: "Weight",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Tổng khối",
                        value: "Volume",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Còn thiếu",
                        value: "RemainAmount",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Dư ví",
                        value: "Wallet",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: ""
                    }
                ];
            }
            return [
                {
                    text: "Khách hàng",
                    value: "Username",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Kho nhận",
                    value: "StoreExpID",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Enum"],
                    values: []
                },
                {
                    text: "Tổng đơn",
                    value: "TotalOrder",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng mã",
                    value: "TotalPack",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng kiện",
                    value: "NumberOfPack",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng cân",
                    value: "Weight",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng khối",
                    value: "Volume",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng tiền",
                    value: "TotalAmount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Đã trả",
                    value: "Payment",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Còn thiếu",
                    value: "RemainAmount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Dư ví",
                    value: "Wallet",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: ""
                }
            ];
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("report/getInventoryReport", param);
            this.$store.dispatch("storeExp/getList");
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        export_data() {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("report/exportInventoryReport", param);
        },
        print_data(item) {
            this.$store.dispatch("orderTransaction/getList", {filter: [
                { column: "UID", value: item.UID || 0, condition: "equal" },
                { column: "Status", value: 4, condition: "equal" },
                { column: "StoreExpID", value: item.StoreExpID || 0, condition: "equal" }]}).then(p => {
                    print_inventory(item, p.data);
            });
        }
    },
    mounted() {
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("REQUEST_CREATE_DATA", this.export_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$off("REQUEST_CREATE_DATA");
    }
};
</script>